export default __webpack_public_path__ + "static/media/Image39.3633481b.png";